
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const ImmigrationPage = () => {
  const services = [
    {
      title: '40+海外律所',
      description: '深度解析政策变化，高效拿下工签/人才移民/投资移民等',
      icon: 'ri-scales-line',
      features: ['专业律师团队', '政策实时跟踪', '多种移民方案', '成功率保障']
    },
    {
      title: '13年规划经验',
      description: '全家全程全方位服务，为职业、投资、生活及家庭保驾护航',
      icon: 'ri-time-line',
      features: ['丰富经验积累', '全家移民规划', '生活安置服务', '长期跟踪支持']
    },
    {
      title: '全球化资源',
      description: '各国商业投资项目、科技创新项目合作，全面提高申请通过率',
      icon: 'ri-global-line',
      features: ['资金实力雄厚', '全球合作网络', '风险控制体系', '成功案例丰富']
    }
  ];

  const countries = [
    { name: '美国', type: 'EB-1/EB-5', period: '2-5年', investment: '80万美元起' },
    { name: '加拿大', type: '联邦技术/投资', period: '1-3年', investment: '120万加币起' },
    { name: '澳大利亚', type: '技术/商业移民', period: '1-4年', investment: '150万澳币起' },
    { name: '新西兰', type: '技术/投资移民', period: '1-3年', investment: '300万纽币起' },
    { name: '英国', type: '投资/创新移民', period: '3-5年', investment: '200万英镑起' },
    { name: '新加坡', type: 'GIP投资移民', period: '2-3年', investment: '250万新币起' }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main>
        {/* Hero Section */}
        <section 
          className="relative py-20 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/f89015c040a5e8948197654c6b9db665.png')`
          }}
        >
          <div className="max-w-7xl mx-auto px-6 text-center text-white">
            <h1 className="text-5xl font-bold mb-6">移民规划</h1>
            <p className="text-xl mb-8 max-w-3xl mx-auto">
              职业生涯与生活品质的双重升级。专业团队为您和家人规划全球化的美好未来
            </p>
            <a 
              href="/#assessment"
              className="inline-block bg-blue-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              立即咨询移民服务
            </a>
          </div>
        </section>

        {/* Services Section */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">核心服务优势</h2>
              <p className="text-xl text-gray-600">专业移民规划服务，为您的全球化生活保驾护航</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {services.map((service, index) => (
                <div key={index} className="bg-white rounded-lg shadow-lg p-8 hover:shadow-xl transition-shadow">
                  <div className="w-16 h-16 bg-blue-600 rounded-lg flex items-center justify-center mb-6 mx-auto">
                    <i className={`${service.icon} text-white text-2xl`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 mb-6 text-center">
                    {service.description}
                  </p>
                  <ul className="space-y-2">
                    {service.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-center text-sm text-gray-700">
                        <i className="ri-check-line text-blue-600 mr-2"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Countries Section */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">热门移民国家</h2>
              <p className="text-xl text-gray-600">多元化移民选择，总有一款适合您的需求</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {countries.map((country, index) => (
                <div key={index} className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg p-6 border border-blue-100">
                  <h3 className="text-lg font-bold text-gray-900 mb-3">{country.name}</h3>
                  <div className="space-y-2">
                    <div className="flex justify-between items-center">
                      <span className="text-sm text-gray-600">移民类型</span>
                      <span className="font-semibold text-gray-800">{country.type}</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-sm text-gray-600">办理周期</span>
                      <span className="font-semibold text-blue-600">{country.period}</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-sm text-gray-600">投资门槛</span>
                      <span className="font-semibold text-green-600">{country.investment}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="text-center mt-12">
              <div className="inline-flex items-center space-x-8 bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-8 py-4 rounded-lg">
                <div className="text-center">
                  <div className="text-2xl font-bold">40+</div>
                  <div className="text-sm opacity-90">海外律所</div>
                </div>
                <div className="w-px h-8 bg-white/30"></div>
                <div className="text-center">
                  <div className="text-2xl font-bold">13年</div>
                  <div className="text-sm opacity-90">规划经验</div>
                </div>
                <div className="w-px h-8 bg-white/30"></div>
                <div className="text-center">
                  <div className="text-2xl font-bold">98%</div>
                  <div className="text-sm opacity-90">成功率</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Immigration Types Section */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">移民方式选择</h2>
              <p className="text-xl text-gray-600">根据您的具体情况，选择最适合的移民路径</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {[
                {
                  title: '技术移民',
                  description: '凭借专业技能和工作经验申请',
                  icon: 'ri-tools-line',
                  advantages: ['门槛相对较低', '周期较短', '成本可控', '适合年轻人']
                },
                {
                  title: '投资移民',
                  description: '通过投资当地经济获得移民资格',
                  icon: 'ri-money-dollar-circle-line',
                  advantages: ['成功率高', '全家移民', '投资回报', '快速通道']
                },
                {
                  title: '创业移民',
                  description: '在目标国家创办企业获得移民身份',
                  icon: 'ri-rocket-line',
                  advantages: ['创业机会', '政策支持', '灵活性强', '发展潜力大']
                }
              ].map((type, index) => (
                <div key={index} className="bg-white rounded-lg shadow-lg p-8">
                  <div className="w-16 h-16 bg-blue-600 rounded-lg flex items-center justify-center mb-6 mx-auto">
                    <i className={`${type.icon} text-white text-2xl`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">
                    {type.title}
                  </h3>
                  <p className="text-gray-600 mb-6 text-center">
                    {type.description}
                  </p>
                  <ul className="space-y-2">
                    {type.advantages.map((advantage, advantageIndex) => (
                      <li key={advantageIndex} className="flex items-center text-sm text-gray-700">
                        <i className="ri-check-line text-blue-600 mr-2"></i>
                        {advantage}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Process Section */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">移民服务流程</h2>
              <p className="text-xl text-gray-600">专业化的移民规划流程，确保每个步骤都精准执行</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-6 gap-4">
              {[
                { step: '01', title: '免费评估', desc: '专业移民顾问评估可行性' },
                { step: '02', title: '方案设计', desc: '量身定制最优移民方案' },
                { step: '03', title: '材料准备', desc: '协助准备所有申请材料' },
                { step: '04', title: '递交申请', desc: '专业团队递交移民申请' },
                { step: '05', title: '跟进审理', desc: '全程跟进申请审理进度' },
                { step: '06', title: '成功移民', desc: '获得身份后的安置服务' }
              ].map((item, index) => (
                <div key={index} className="text-center">
                  <div className="w-14 h-14 bg-blue-600 text-white rounded-full flex items-center justify-center text-sm font-bold mx-auto mb-3">
                    {item.step}
                  </div>
                  <h3 className="text-base font-bold text-gray-900 mb-2">{item.title}</h3>
                  <p className="text-gray-600 text-xs">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default ImmigrationPage;
